import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRanks from "./components/HotRanks";
import AceColumns from "./components/AceColumns";
import Topics from "./components/Topics";
import ContentFlow from "./components/ContentFlow";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HotRanks />
        <AceColumns />
        <Topics />
        <ContentFlow />
        <Reviews />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}